package com.rainbowclubs.rainbow.domain.use_cases.club

import com.rainbowclubs.rainbow.data.cache.ClubCache

class CacheSelectedClubUseCase(
    private val clubCache: ClubCache,
) {
    operator fun invoke(clubId: String) {
        clubCache.selectedClub = clubId
    }
}
